import { useCanRead } from '@artic/api-client';
import { useFeatureFlag } from '@artic/ui/feature-flags';
import { MaterialsIcon } from '@artic/ui/icons/nav';
import { getQualityUrl } from '@artic/ui/lib/environment';
import { useTranslation } from 'react-i18next';

import type { LinkItemProps } from '~/layout/SidebarLayout';

/**
 * Neo's Materials nav section (ENG-1022), mirrored into the Hub: the same items, order and
 * flag as `quality-sidebar.tsx`.
 *
 * Material Usage is a Neo page, so the item is an absolute href. With `bill_of_materials` off
 * it is disabled rather than hidden, as in Neo, and nothing is admin-gated. Material Imports
 * lives under Settings → Imports (`useImportsNavSubheader`).
 */
export function useMaterialsNavGroup(): LinkItemProps {
  const { t } = useTranslation('translation');
  const billOfMaterials = useFeatureFlag('bill_of_materials');
  const canReadMaterials = useCanRead('materials');
  const views = `${getQualityUrl()}/materials`;

  return {
    name: t('nav.materials'),
    icon: MaterialsIcon,
    hide: !canReadMaterials,
    children: [{ name: t('nav.usage'), href: `${views}/usage`, disabled: !billOfMaterials }],
  };
}
